import moment from 'moment-timezone';
import { Discount, Price } from 'shared-types/Common';

import { isTimestampsFromSameDay } from '@utils/helpers';
import { EntityTypes } from '@common-types/Entities';

export const getAvailability = (startDate, fetchAvailability, change, entityType) => {
  change('visitDate', startDate);
  if (entityType === EntityTypes.TREATMENT || entityType === EntityTypes.FACILITY) {
    const requests = new Array(7)
      .fill('')
      .map((_, index) => fetchAvailability(moment(startDate).add(index, 'days')));
    Promise.all(requests).catch((err) => console.warn('Fetching availability failed: ', err));
  } else {
    fetchAvailability(startDate, moment(startDate).add(6, 'days'));
  }
};

type AvilabilityType = {
  startDateTime: Date | string;
  price: Price;
  endDateTime: Date | string;
  discount?: Discount;
};

export const getSliderDates = (
  availability: AvilabilityType[] = [],
  startDay: string,
  numberOfDays = 7,
  override = false
) =>
  new Array(numberOfDays).fill(null).map((_, i) => {
    const date = moment(startDay).add(i, 'days');

    const todaysTimestamps = availability.length
      ? availability?.filter((option) => isTimestampsFromSameDay(option.startDateTime, date))
      : [];

    const cheapest = todaysTimestamps.reduce(
      (min: AvilabilityType | null, current) =>
        min && min?.price?.amount < current?.price?.amount ? min : current,
      null
    );

    const todaysTimestampsWithDiscount = todaysTimestamps.filter((timestamp) => timestamp.discount);

    const todaysTimestampsWithCheapestDiscount = todaysTimestampsWithDiscount.reduce(
      (min: AvilabilityType | null, current) =>
        min?.discount &&
        current.discount &&
        min?.discount?.discountedPrice?.amount < current?.discount?.discountedPrice?.amount
          ? min
          : current,
      null
    );

    return {
      price: cheapest?.price,
      date,
      disableDate:
        !override &&
        (!availability?.length ||
          !availability.find((option) => isTimestampsFromSameDay(option.startDateTime, date))),
      discount: todaysTimestampsWithCheapestDiscount?.discount,
    };
  });

export const startDateAfterChange = (
  startDate,
  change,
  changeJourneyParam,
  fetchAvailability,
  entityType
) => {
  change('visitDate', null);
  change('arrivalTime', null);
  changeJourneyParam('spaDate', startDate);
  getAvailability(startDate, fetchAvailability, change, entityType);
};

export const visitDayAfterChange = (visitDayDate, change, changeJourneyParam) => {
  change('arrivalTime', null);
  change('visitDate', visitDayDate);
  changeJourneyParam('spaDate', visitDayDate);
};
